<template>
  <v-dialog max-width="540" :value="visible" content-class="rounded-10" style="z-index: 15" @input="$emit('input', $event)">
    <v-sheet class="rounded-10 px-4 px-md-4 py-4 py-md-10 d-flex flex-column align-center" color="#fffbf2" style="border: 2px solid #bebebe">
      <img v-if="currentPage !== 2 || isMakerShotPolicy" src="@/assets/warning.png" class="icon" />

      <!-- 첫번째 페이지 -->
      <div v-if="currentPage === 1" style="width: 100%">
        <div class="text-h6 text-md-h5 text-center black--text text--darken-2 font-weight-bold my-1 my-md-2" style="word-break: keep-all; white-space: normal">{{ $t("dialog.refund-title") }}</div>
        <p class="text-center px-1 text-body-2 text-md-body-1 text-wrap" v-html="$t('dialog.refund-warning-message')"></p>

        <v-card flat width="100%" class="d-flex flex-column align-center py-2 py-md-4" style="border: 2px solid #dadada">
          <v-card-text class="text-center pa-0 text-body-2 text-md-body-1" style="color: #545454; font-size: 16px">{{ $t("dialog.refund-warning-list-1") }}</v-card-text>
          <v-card-text class="text-center pa-0 mt-2 text-body-2 text-md-body-1" style="color: #545454; font-size: 16px">{{ $t("dialog.refund-warning-list-2") }}</v-card-text>
          <v-card-text class="text-center pa-0 mt-2 text-body-2 text-md-body-1" style="color: #545454; font-size: 16px">{{ $t("dialog.refund-warning-list-3") }}</v-card-text>
          <v-card-text class="text-center pa-0 mt-2 text-body-2 text-md-body-1" style="color: #545454; font-size: 16px">{{ $t("dialog.refund-warning-list-4") }}</v-card-text>
        </v-card>
        <v-container class="d-flex flex-start my-1 my-md-2 py-0" fluid>
          <ul class="text-body-2 text-md-body-1 grey--text text--darken-2 text-wrap">
            <li>{{ $t("dialog.refund-warning-list-5") }}</li>
            <li>{{ $t("dialog.refund-warning-list-6") }}</li>
          </ul>
        </v-container>
        <v-container class="d-flex justify-center py-1 py-md-2" v-if="!readonly">
          <span class="grey--text text--darken-2 text-body-2 text-md-body-1">{{ $t("dialog.refund-agree-check-label") }}</span>
          <v-simple-checkbox v-model="isCheck1" color="primary" />
        </v-container>
      </div>

      <!-- 두번째 페이지 -->
      <div v-else-if="currentPage === 2" class="px-0" style="width: 100%">
        <!-- 두번째 페이지 내용 -->
        <template v-if="isMakerShotPolicy">
          <div class="text-h6 text-md-h5 text-center black--text text--darken-2 font-weight-bold my-1 my-md-2">{{ $t("dialog.noshow-warning-title") }}</div>
          <div class="text-center px-4 text-body-2 text-md-body-1 text-wrap" v-html="$t('dialog.noshow-warning-message-1', { shootingTime: SHOOTING_TIME })"></div>
          <div class="text-center px-4 text-body-2 text-md-body-1 text-wrap" v-html="$t('dialog.noshow-warning-message-2')"></div>

          <v-img :src="getNoshowGuideImage()" width="90%" max-width="400" class="my-2 mx-auto" aspect-ratio="2.8" contain></v-img>

          <v-container class="d-flex flex-start py-0" fluid>
            <ul class="text-body-2 text-md-body-1 grey--text text--darken-2">
              <li>{{ $t("dialog.noshow-warning-list-1") }}</li>
            </ul>
          </v-container>
        </template>
        <template v-else>
          <section class="premium-policy" :aria-label="$t('dialog.premium-noshow-title')">
            <h2 class="premium-policy__title">{{ $t("dialog.premium-noshow-title") }}</h2>
            <p class="premium-policy__subtitle">{{ $t("dialog.premium-noshow-subtitle") }}</p>

            <div class="premium-policy__list">
              <div class="premium-policy__row">
                <span class="premium-policy__number">01</span>
                <span class="premium-policy__copy">{{ $t("dialog.premium-noshow-row-1") }}</span>
              </div>
              <div class="premium-policy__row premium-policy__row--active">
                <span class="premium-policy__number">02</span>
                <span class="premium-policy__copy">{{ $t("dialog.premium-noshow-row-2") }}</span>
              </div>
              <div class="premium-policy__row">
                <span class="premium-policy__number">03</span>
                <span class="premium-policy__copy">{{ $t("dialog.premium-noshow-row-3") }}</span>
              </div>
            </div>

            <div class="premium-policy__alert">
              <v-icon class="premium-policy__alert-icon" size="20">mdi-alert-circle-outline</v-icon>
              <strong>{{ $t("dialog.premium-noshow-alert") }}</strong>
            </div>
            <p class="premium-policy__note">{{ $t("dialog.premium-noshow-note") }}</p>
          </section>
        </template>

        <v-container class="d-flex justify-center py-1 py-md-2" v-if="!readonly">
          <span class="grey--text text--darken-2 text-body-2 text-md-body-1">
            {{ $t(isMakerShotPolicy ? "dialog.noshow-agree-check-label" : "dialog.premium-noshow-agree-check-label") }}
          </span>
          <v-simple-checkbox v-model="isCheck2" color="primary" />
        </v-container>
      </div>

      <!-- 세번째 페이지 -->
      <div v-else-if="currentPage === 3 && isMakerShotPolicy" class="px-0" style="width: 100%">
        <!-- 세번째 페이지 내용 -->
        <div class="text-h6 text-md-h5 text-center black--text text--darken-2 font-weight-bold my-1 my-md-2 text-wrap">{{ $t("dialog.composite-warning-title") }}</div>
        <div class="text-center px-4 text-body-2 text-md-body-1 text-wrap" v-html="$t('dialog.composite-warning-message-1')"></div>
        <v-img src="@/assets/reservation/composite_bg.png" width="90%" max-width="400" class="my-1 mx-auto" aspect-ratio="1.9" contain></v-img>

        <v-container class="d-flex flex-start py-0" fluid>
          <ul class="text-body-2 text-md-body-1 grey--text text--darken-2">
            <li>{{ $t("dialog.composite-warning-list-1") }}</li>
            <li>{{ $t("dialog.composite-warning-list-2") }}</li>
          </ul>
        </v-container>

        <v-container class="d-flex justify-center py-1 py-md-2" v-if="!readonly">
          <span class="grey--text text--darken-2 text-body-2 text-md-body-1">{{ $t("dialog.quality-agree-check-label") }}</span>
          <v-simple-checkbox v-model="isCheck3" color="primary" />
        </v-container>
      </div>

      <div class="d-flex justify-center">
        <span class="grey--text text--darken-2 text-body-1"> <v-icon medium>mdi-chevron-left</v-icon>&nbsp;&nbsp;{{ currentPage }} / {{ totalPages }}&nbsp;&nbsp;<v-icon medium>mdi-chevron-right</v-icon> </span>
      </div>

      <v-container fluid class="d-flex justify-center py-1 py-md-2">
        <v-btn color="white" class="dialog_btn rounded-2 mr-2 grey--text" width="35%" style="font-size: 20px" depressed @click="prevPage" large>
          {{ currentPage === 1 ? $t("button.back") : $t("button.prev") }}
        </v-btn>

        <v-btn
          color="#D8207E"
          class="dialog_btn rounded-2 ml-2"
          style="font-size: 20px"
          width="35%"
          depressed
          @click="nextPage"
          large
          :disabled="(currentPage === 1 && !isCheck1) || (currentPage === 2 && !isCheck2) || (currentPage === 3 && !isCheck3)"
        >
          {{ currentPage === totalPages ? $t("button.ok") : $t("button.next") }}
        </v-btn>
      </v-container>
    </v-sheet>
  </v-dialog>
</template>

<script>
import { SHOOTING_TIME } from "@/constant"
import { mapState } from "vuex"

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    productType: {
      type: String,
      default: "makershot",
    },
  },
  data: () => ({
    isCheck1: false,
    isCheck2: false,
    isCheck3: false,
    currentPage: 1,
  }),
  computed: {
    ...mapState(["lang"]),
    SHOOTING_TIME() {
      return SHOOTING_TIME
    },
    isMakerShotPolicy() {
      return String(this.productType).toLowerCase() === "makershot"
    },
    totalPages() {
      return this.isMakerShotPolicy ? 3 : 2
    },
  },
  created() {
    if (this.readonly) {
      this.isCheck1 = true
      this.isCheck2 = true
      this.isCheck3 = true
    }
  },
  methods: {
    nextPage() {
      if (this.currentPage === this.totalPages) {
        this.$emit("agree")
      } else {
        this.currentPage++
      }
    },
    prevPage() {
      if (this.currentPage === 1) {
        this.$emit("cancel")
      } else {
        this.currentPage--
      }
    },
    getNoshowGuideImage() {
      let fileName = "noshow-guide.png"
      switch (this.lang) {
        case "jp":
          fileName = "noshow-guide-jp.png"
          break
        case "en":
          fileName = "noshow-guide-en.png"
          break
        default:
          fileName = "noshow-guide.png"
          break
      }

      return require(`@/assets/reservation/${fileName}`)
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.currentPage = 1
        this.isCheck1 = false
        this.isCheck2 = false
        this.isCheck3 = false
      }
    },
  },
}
</script>

<style scoped>
.icon {
  width: 30px;
  height: 30px;
}

@media (min-width: 600px) {
  .icon {
    width: 60px;
    height: 60px;
  }
}

.dialog_btn {
  border: 2px solid #dadada !important;
  font-size: 16px;
}
::v-deep .v-btn:not(.v-btn--disabled) {
  color: white;
}

.text-wrap {
  white-space: pre-wrap; /* CSS3 */
  word-wrap: break-word; /* IE */
  word-break: keep-all; /* 긴 단어 처리 */
  max-width: 100%; /* 컨테이너 최대 너비 설정 */
}

.premium-policy {
  width: 100%;
  padding: 6px 8px 2px;
  color: #2f292d;
}

.premium-policy__title {
  margin: 0;
  color: #2b2428;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(23px, 6vw, 31px);
  font-weight: 500;
  line-height: 1.25;
  text-align: center;
  word-break: keep-all;
}

.premium-policy__subtitle {
  margin: 8px 0 20px;
  color: #766d71;
  font-size: 13px;
  line-height: 1.55;
  text-align: center;
  word-break: keep-all;
}

.premium-policy__list {
  display: grid;
  gap: 8px;
}

.premium-policy__row {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  min-height: 56px;
  padding: 10px 14px;
  border: 1px solid #e4ddd9;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.64);
}

.premium-policy__row--active {
  border-color: #d8207e;
  background: #fff7fb;
  box-shadow: 0 6px 16px rgba(216, 32, 126, 0.08);
}

.premium-policy__number {
  color: #b9adb2;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 15px;
  line-height: 1;
}

.premium-policy__row--active .premium-policy__number {
  color: #d8207e;
}

.premium-policy__copy {
  color: #433b3f;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.45;
  word-break: keep-all;
}

.premium-policy__alert {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f7e9ef;
  color: #a53a66;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
}

.premium-policy__alert-icon {
  color: #b84876 !important;
}

.premium-policy__note {
  margin: 10px 4px 0;
  color: #7c7277;
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
  word-break: keep-all;
}

@media (min-width: 600px) {
  .premium-policy {
    padding: 2px 22px 4px;
  }

  .premium-policy__subtitle {
    margin-bottom: 24px;
    font-size: 14px;
  }

  .premium-policy__row {
    min-height: 62px;
    padding: 12px 18px;
  }

  .premium-policy__copy {
    font-size: 15px;
  }
}
</style>
